module.exports = __webpack_public_path__ + "static/media/1r.72185a05.JPG";